import { useState } from "react";
import Swal from "sweetalert2";
import api from "../api/axios";

function AddCommunityCenter() {

    const [form, setForm] = useState({
        communityCenterName: "",
        communityCenterLocation: "",
        latitude: "",
        longitude: "",
        areaPerAcre: "",
        ratePerDay: "",
        cleaningCharges: "",
        securityCharges: "",
        gstPercentage: 18,
        address: "",
        description: "",
        contactPerson: "",
        contactNumber: "",
        capacity: "",
        facilities: "",
        isActive: true,
        remarks: ""
    });

    const [image, setImage] = useState(null);
    const [video, setVideo] = useState(null);
    const [loading, setLoading] = useState(false);


    const handleChange = (e) => {

        const {
            name,
            value,
            type,
            checked
        } = e.target;

        setForm(prev => ({
            ...prev,
            [name]:
                type === "checkbox"
                    ? checked
                    : value
        }));
    };


    // ============================
    // CALCULATION
    // ============================

    const rate =
        Number(form.ratePerDay) || 0;

    const cleaning =
        Number(form.cleaningCharges) || 0;

    const security =
        Number(form.securityCharges) || 0;

    const gstPercentage =
        Number(form.gstPercentage) || 0;


    const subtotal =
        rate +
        cleaning +
        security;


    const gst =
        (subtotal * gstPercentage) / 100;


    const total =
        subtotal + gst;


    // ============================
    // SUBMIT
    // ============================

    const handleSubmit = async (e) => {

        e.preventDefault();


        if (!form.communityCenterName.trim()) {

            Swal.fire(
                "Validation",
                "Community Center Name is required",
                "warning"
            );

            return;
        }


        if (!form.communityCenterLocation.trim()) {

            Swal.fire(
                "Validation",
                "Community Center Location is required",
                "warning"
            );

            return;
        }


        if (!form.latitude ||
            !form.longitude) {

            Swal.fire(
                "Validation",
                "Latitude and Longitude are required",
                "warning"
            );

            return;
        }


        if (!form.areaPerAcre) {

            Swal.fire(
                "Validation",
                "Area Per Acre is required",
                "warning"
            );

            return;
        }


        if (!form.ratePerDay) {

            Swal.fire(
                "Validation",
                "Rate Per Day is required",
                "warning"
            );

            return;
        }


        if (!image) {

            Swal.fire(
                "Validation",
                "Community Center Image is required",
                "warning"
            );

            return;
        }


        try {

            setLoading(true);


            const data =
                new FormData();


            data.append(
                "CommunityCenterName",
                form.communityCenterName
            );

            data.append(
                "CommunityCenterLocation",
                form.communityCenterLocation
            );

            data.append(
                "Latitude",
                form.latitude
            );

            data.append(
                "Longitude",
                form.longitude
            );

            data.append(
                "AreaPerAcre",
                form.areaPerAcre
            );

            data.append(
                "RatePerDay",
                form.ratePerDay
            );

            data.append(
                "CleaningCharges",
                form.cleaningCharges || 0
            );

            data.append(
                "SecurityCharges",
                form.securityCharges || 0
            );

            data.append(
                "GSTPercentage",
                form.gstPercentage
            );

            data.append(
                "Address",
                form.address
            );

            data.append(
                "Description",
                form.description
            );

            data.append(
                "ContactPerson",
                form.contactPerson
            );

            data.append(
                "ContactNumber",
                form.contactNumber
            );

            data.append(
                "Capacity",
                form.capacity || ""
            );

            data.append(
                "Facilities",
                form.facilities
            );

            data.append(
                "IsActive",
                form.isActive
            );

            data.append(
                "Remarks",
                form.remarks
            );


            // ============================
            // USER ID
            // ============================

            const userId =
                localStorage.getItem("id");


            if (userId) {

                data.append(
                    "CreatedBy",
                    userId
                );
            }


            // ============================
            // FILES
            // ============================

            data.append(
                "image",
                image
            );


            if (video) {

                data.append(
                    "video",
                    video
                );
            }


            await api.post(
                "/CommunityCenter/Add",
                data,
                {
                    headers: {
                        "Content-Type":
                            "multipart/form-data"
                    }
                }
            );


            Swal.fire(
                "Success",
                "Community Center added successfully",
                "success"
            );


            // RESET

            setForm({
                communityCenterName: "",
                communityCenterLocation: "",
                latitude: "",
                longitude: "",
                areaPerAcre: "",
                ratePerDay: "",
                cleaningCharges: "",
                securityCharges: "",
                gstPercentage: 18,
                address: "",
                description: "",
                contactPerson: "",
                contactNumber: "",
                capacity: "",
                facilities: "",
                isActive: true,
                remarks: ""
            });


            setImage(null);
            setVideo(null);
           setImage(null);
setVideo(null);

const imageInput = document.getElementById("communityImage");

if (imageInput) {
    imageInput.value = "";
}

const videoInput = document.getElementById("communityVideo");

if (videoInput) {
    videoInput.value = "";
}


        } catch (error) {

            console.error(error);

            // Swal.fire(
            //     "Error",
            //     error.response?.data?.message ||
            //     "Something went wrong",
            //     "error"
            // );

            Swal.fire({
                    icon: "error",
                    title: "Error",
                    text:
                      error.response?.data?.message ||
                      error.response?.data ||
                      "Something went wrongd",
                  });

        } finally {

            setLoading(false);
        }
    };


    return (

        <div className="container-fluid py-3">

            <div className="card shadow-sm">

                <div className="card-header">

                    <h4 className="mb-0">
                        Add Community Center
                    </h4>

                </div>


                <div className="card-body">

                    <form onSubmit={handleSubmit}>

                        <div className="row">


                            {/* NAME */}

                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    Community Center Name
                                    <span className="text-danger">
                                        *
                                    </span>
                                </label>

                                <input
                                    type="text"
                                    name="communityCenterName"
                                    value={
                                        form.communityCenterName
                                    }
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="Enter Community Center Name"
                                />

                            </div>


                            {/* LOCATION */}

                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    Community Center Location
                                    <span className="text-danger">
                                        *
                                    </span>
                                </label>

                                <input
                                    type="text"
                                    name="communityCenterLocation"
                                    value={
                                        form.communityCenterLocation
                                    }
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="Enter Location"
                                />

                            </div>


                            {/* LATITUDE */}

                            <div className="col-md-3 mb-3">

                                <label className="form-label">
                                    Latitude
                                    <span className="text-danger">
                                        *
                                    </span>
                                </label>

                                <input
                                    type="number"
                                    step="any"
                                    name="latitude"
                                    value={form.latitude}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="28.6139000"
                                />

                            </div>


                            {/* LONGITUDE */}

                            <div className="col-md-3 mb-3">

                                <label className="form-label">
                                    Longitude
                                    <span className="text-danger">
                                        *
                                    </span>
                                </label>

                                <input
                                    type="number"
                                    step="any"
                                    name="longitude"
                                    value={form.longitude}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="77.2090000"
                                />

                            </div>


                            {/* AREA */}

                            <div className="col-md-2 mb-3">

                                <label className="form-label">
                                    Area Per Acre
                                    <span className="text-danger">
                                        *
                                    </span>
                                </label>

                                <input
                                    type="number"
                                    step="0.01"
                                    name="areaPerAcre"
                                    value={form.areaPerAcre}
                                    onChange={handleChange}
                                    className="form-control"
                                     placeholder="Area Per Acre"
                                />

                            </div>


                            {/* CAPACITY */}

                            <div className="col-md-2 mb-3">

                                <label className="form-label">
                                    Capacity
                                </label>

                                <input
                                    type="number"
                                    name="capacity"
                                    value={form.capacity}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="No. of Persons"
                                />

                            </div>

{/* FACILITIES */}

                            <div className="col-md-2 mb-3">

                                <label className="form-label">
                                    Facilities
                                </label>

                                <input
                                    type="text"
                                    name="facilities"
                                    value={
                                        form.facilities
                                    }
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="Parking, AC, Chairs..."
                                />

                            </div>

{/* ADDRESS */}

                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    Address
                                </label>

                                <textarea
                                    name="address"
                                    value={form.address}
                                    onChange={handleChange}
                                    className="form-control"
                                    rows="2"
                                />

                            </div>

 {/* DESCRIPTION */}

                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    Description
                                </label>

                                <textarea
                                    name="description"
                                    value={
                                        form.description
                                    }
                                    onChange={handleChange}
                                    className="form-control"
                                    rows="3"
                                />

                            </div>

                            {/* RATE */}

                            <div className="col-md-2 mb-3">

                                <label className="form-label">
                                    Rate Per Day
                                    <span className="text-danger">
                                        *
                                    </span>
                                </label>

                                <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    name="ratePerDay"
                                    value={form.ratePerDay}
                                    onChange={handleChange}
                                    className="form-control"
                                />

                            </div>


                            {/* CLEANING */}

                            <div className="col-md-2 mb-3">

                                <label className="form-label">
                                    Cleaning Charges
                                </label>

                                <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    name="cleaningCharges"
                                    value={
                                        form.cleaningCharges
                                    }
                                    onChange={handleChange}
                                    className="form-control"
                                />

                            </div>


                            {/* SECURITY */}

                            <div className="col-md-2 mb-3">

                                <label className="form-label">
                                    Security Charges
                                </label>

                                <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    name="securityCharges"
                                    value={
                                        form.securityCharges
                                    }
                                    onChange={handleChange}
                                    className="form-control"
                                />

                            </div>


                            {/* GST */}

                            <div className="col-md-2 mb-3">

                                <label className="form-label">
                                    GST %
                                </label>

                                <input
                                    type="number"
                                    step="0.01"
                                    name="gstPercentage"
                                    value={
                                        form.gstPercentage
                                    }
                                    onChange={handleChange}
                                    className="form-control"
                                />

                            </div>


                            {/* GST AMOUNT */}

                            <div className="col-md-2 mb-3">

                                <label className="form-label">
                                    GST Amount
                                </label>

                                <input
                                    type="text"
                                    value={
                                        gst.toFixed(2)
                                    }
                                    readOnly
                                    className="form-control"
                                />

                            </div>


                            {/* TOTAL */}

                            <div className="col-md-2 mb-3">

                                <label className="form-label">
                                    Total Amount
                                </label>

                                <input
                                    type="text"
                                    value={
                                        total.toFixed(2)
                                    }
                                    readOnly
                                    className="form-control fw-bold"
                                />

                            </div>


                            


                           


                            {/* CONTACT */}

                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    Contact Person
                                </label>

                                <input
                                    type="text"
                                    name="contactPerson"
                                    value={
                                        form.contactPerson
                                    }
                                    onChange={handleChange}
                                    className="form-control"
                                />

                            </div>


                            {/* MOBILE */}

                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    Contact Number
                                </label>

                                <input
                                    type="tel"
                                    name="contactNumber"
                                    value={
                                        form.contactNumber
                                    }
                                    onChange={handleChange}
                                    className="form-control"
                                    maxLength="10"
                                />

                            </div>


                            
                            {/* IMAGE */}

                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    Community Center Image
                                    <span className="text-danger">
                                        *
                                    </span>
                                </label>

                                <input
                                    id="communityImage"
                                    type="file"
                                    accept="image/jpeg,image/png,image/webp"
                                    className="form-control"
                                    onChange={(e) =>
                                        setImage(
                                            e.target.files?.[0] ||
                                            null
                                        )
                                    }
                                />

                            </div>


                            {/* VIDEO */}

                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    Community Center Video
                                </label>

                                <input
                                    id="communityVideo"
                                    type="file"
                                    accept="video/mp4,video/webm,video/quicktime"
                                    className="form-control"
                                    onChange={(e) =>
                                        setVideo(
                                            e.target.files?.[0] ||
                                            null
                                        )
                                    }
                                />

                            </div>

                            {/* REMARKS */}

                            <div className="col-md-12 mb-3">

                                <label className="form-label">
                                    Remarks
                                </label>

                                <textarea
                                    name="remarks"
                                    value={form.remarks}
                                    onChange={handleChange}
                                    className="form-control"
                                    rows="2"
                                />

                            </div>


                            {/* ACTIVE */}

                            <div className="col-md-12 mb-3">

                                <div className="form-check">

                                    <input
                                        id="isActive"
                                        type="checkbox"
                                        name="isActive"
                                        checked={
                                            form.isActive
                                        }
                                        onChange={handleChange}
                                        className="form-check-input"
                                    />

                                    <label
                                        htmlFor="isActive"
                                        className="form-check-label"
                                    >
                                        Active
                                    </label>

                                </div>

                            </div>

                        </div>


                        {/* BUTTON */}

                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={loading}
                        >

                            {loading
                                ? "Saving..."
                                : "Save Community Center"}

                        </button>

                    </form>

                </div>

            </div>

        </div>
    );
}

export default AddCommunityCenter;